import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Keyboard } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

import 'swiper/swiper.css';

document.addEventListener('alpine:init', () => {
    Alpine.data('initBeforeAfterSlider', () => {
        return {
            shown: false,
            checked: false,
            swiper: {},
            // resetChecked() {
            //     this.checked = false;
            // },
            start() {
                if (!this.shown) {
                    this.shown = true;

                    const swiperParams: SwiperOptions = {
                        modules: [Navigation, Keyboard],
                        init: false,
                        spaceBetween: 8,
                        slidesPerView: 1.05,
                        breakpoints: {
                            1024: {
                                slidesPerView: 1,
                            },
                        },
                        loop: false,
                        keyboard: {
                            enabled: true,
                        },
                        navigation: {
                            nextEl: this.$refs.next,
                            prevEl: this.$refs.prev,
                        }
                    };

                    const swiper = new Swiper(
                        this.$refs.swiperContainer,
                        swiperParams,
                    );
                    this.swiper = swiper;

                    // this.swiper.on('navigationPrev', this.resetChecked);
                    // this.swiper.on('navigationNext', this.resetChecked);

                    this.$nextTick(() => {
                        swiper.init();
                    });
                }

            },
        };
    });
});
